export const sanitizePathname = (path: string | undefined) =>
  path?.replaceAll(
    new RegExp(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/g),
    ':id'
  );

export const PAGE_TITLE_FROM_ROUTE: Record<string, string> = {
  // Datasets
  '/imports/datasets/:id': 'Origin data import',
  // Partners
  '/partners/:id': 'Partner overview',
  '/partners/:id/sites': 'Partner sites',
  '/partners/:id/components': 'Partner components',
  '/partners/:id/activities': 'Partner activities',
  '/partners/:id/documents': 'Partner documents',
  '/partners/:id/requests': 'Partner requests',
  // Supply chains
  '/supply-chains/active/:id/:id': 'Supply chain overview',
  '/supply-chains/active/:id/:id/editor': 'Supply chain mapping',
  '/supply-chains/archived/:id/:id': 'Supply chain overview',
  '/supply-chains/archived/:id/:id/editor': 'Supply chain mapping',
  // Component chains
  '/component-chains/:id': 'Component chain overview',
  '/component-chains/:id/editor': 'Component chain mapping',
  // Components
  '/components/:id': 'Component overview',
  // Sites
  '/sites/:id': 'Cluster/Site overview',
  '/sites/:id/activities': 'Site overview',
  '/sites/:id/sites': 'Cluster sites ',
  '/sites/:id/documents': 'Site documents',
  '/sites/:id/documents/internal': 'Site documents',
  '/sites/:id/documents/shared': 'Site documents',
  '/sites/:id/plots': 'Site plots',
  // Plots
  '/sites/:id/plots/:id': 'Plot overview',
  '/sites/:id/plots/:id/documents': 'Plot documents',
  '/sites/:id/plots/:id/documents/internal': 'Plot documents',
  '/sites/:id/plots/:id/documents/shared': 'Plot documents',
  // Activities
  '/activities/:id': 'Activity overview',
  // Documents
  '/documents/internal/:id': 'Document overview',
  '/documents/shared/:id': 'Document overview',
  '/documents/requested/:id': 'Document overview',
  // Product pages
  '/products/active/:id': 'Product overview',
  '/products/active/:id/editor': 'Product ',
  '/products/archived/:id': 'Product overview',
  '/products/archived/:id/editor': 'Product ',
};
